import React from "react";
import ChartSidebarAccordion from "../ChartSidebarAccordion";
import { useSelector } from "react-redux";
import { Typography } from "@material-ui/core";
import useStyles from "../Styles";
import { aboutEntityText, polygonAboutVisualText } from "../AboutSidebar/AboutTexts";

function PolygonMapAboutTab() {
  const { polgon_map_tab, city_selected, irrigation_district_selected } =
    useSelector((state) => state.technical_view);
  const classes = useStyles();
  return (
    <>
      <ChartSidebarAccordion
        group_name={
          //   central_az_tab === "irrigation_district"
          //     ? `Central Arizona ${irrigation_district_selected.name} Water Deliveries`
          //     : `Central Arizona ${city_selected.name} Water Uses`
          "About the Visual"
        }
        accordion_name={'about'}
      >
        <Typography
          variant="body2"
          component="p"
          className={classes.aboutContent}
        >
            {
              polygonAboutVisualText(polgon_map_tab)
            }

        </Typography>
      </ChartSidebarAccordion>
      <ChartSidebarAccordion
        group_name={
          polgon_map_tab === "irrigation_district"
            ? `Entity: ${irrigation_district_selected.name}`
            : `Entity: ${city_selected.name}`
        }
        accordion_name={'entity'}
      >
        <Typography
          variant="body2"
          component="p"
          className={classes.aboutContent}
        >
          {aboutEntityText['CITY'][city_selected.name] ?aboutEntityText['CITY'][city_selected.name] :"Information coming soon..." }
        </Typography>
      </ChartSidebarAccordion>
      {/* <ChartSidebarAccordion
        group_name={
          //   central_az_tab === "irrigation_district"
          //     ? `Entity: ${irrigation_district_selected.name}`
          //     : `Entity: ${city_selected.name}`
          `Scenario`
        }
      >
        <Typography
          variant="body2"
          component="p"
          className={classes.aboutScenarioTitle}
        >
          Name of Scenario
        </Typography>
        <Typography
          variant="body2"
          component="p"
          className={classes.aboutScenario}
        >
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim venia, quis nostrud exercitation ullamco labo is nisi ut aliquip
          ex ea com.
        </Typography>
      </ChartSidebarAccordion> */}
    </>
  );
}

export default PolygonMapAboutTab;
